import { createContext } from "react";
import { storeUtils } from "./store-utils";
// import { storeUtils } from "./store";
const s = storeUtils.namespace('store-page-context')

export interface IPageScrollPosition{
    x:number
    y:number
}

function create(){
    return createContext(s)
}
export const StorePageContext = createContext<any>(s)

export const StorePageDynamicContext = createContext<Record<string, any>>({})